import './css/App.css';
import Container from "@mui/material/Container";
import ReactGA from "react-ga4";
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import AboutPage from "./component/Page/AboutPage.jsx";
import Contact from "./component/Contact.jsx";
import IconButton from '@mui/material/IconButton';
import Avatar from "@mui/material/Avatar";
import LoginIcon from '@mui/icons-material/Login';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import TwoStepLessons from "./component/Page/TwoStepLessons.jsx";
import DailyCalendarPage from "./component/Page/DailyCalendarPage.jsx";
import ArtistPage from "./component/Page/ArtistPage.jsx";
import {TwoStepGuide} from "./component/Page/TwoStepGuide.jsx";
import {EventPage} from "./component/Page/EventPage.jsx";
import VenuePage from "./component/Page/VenuePage.jsx";
import {EventEditPage} from "./component/Page/EventEditPage.tsx";
import {CalendarIntegrationPage} from "./component/Page/Account/CalendarIntegrationPage.jsx";
import {AccountEventsPage} from "./component/Page/AccountEventsPage.jsx";
import {PrivacyPage} from "./component/Page/PrivacyPage.jsx";
import {AdminPage} from "./component/AdminPage.jsx";
import {AccountPage} from "./component/Page/Account/AccountPage.jsx";
import VenueOutOfTownPage from "./component/Page/VenueOutOfTownPage.jsx";
import EditVenuePage from "./component/Page/EditVenuePage.jsx";
import VenueInTownPage from "./component/Page/VenueInTownPage.jsx";
import TodayPage from "./component/Page/TodayPage.jsx";
import {OriginalCalendarPage} from "./component/Page/OriginalCalendarPage.jsx";
import {SiteMap} from "./component/SiteMap.jsx";
import {DanceEventProvider} from "./component/DanceEventProvider.jsx";
import {WhereToDancePage} from "./component/Page/WhereToDancePage.jsx";
import {OutOfTownURI} from "./component/Button/OutOfTownButton.jsx";
import {OriginalCalendarURI} from "./component/Button/OriginalCalendarButton.jsx";
import {InTownURI} from "./component/Button/InTownButton.jsx";
import {DailyCalendarURI} from "./component/Button/DailyCalendarButton.jsx";
import AccountPlaylistPage from "./component/Page/Account/PlaylistPage.jsx";
import AccountInstagramPage from './component/Page/Account/InstagramPage.jsx';
import CommunityPlaylistPage from "./component/Page/Community/PlaylistPage.jsx";
import CommunityInstagramPostPage from './component/Page/Community/InstagramPostPage.jsx';
import CommunityPage from "./component/Page/CommunityPage.jsx";
import AuthPage, { AuthProvider, useAuth } from "./component/Auth/AuthPage.jsx";
import UserAccountPage from "./component/Page/UserAccountPage.jsx";
import SiteMenu from "./component/Menu/SiteMenu.jsx";
import { RSVPProvider } from './component/RSVPContext.jsx';
import LatestAnnouncement from './component/Page/Announcement.jsx';
import AnnouncementList from './component/Page/AnnouncementList.jsx';
import { ArtistListPage } from './component/Page/ArtistListPage.jsx';
import { UserProfilePage } from './component/Page/UserProfilePage.jsx';
import { UserProfileListPage } from './component/Page/UserProfileListPage.jsx';
import CuratorPage from "./component/Page/Curator.jsx";
import ContentPage from "./component/Page/ContentPage.jsx";
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import {LogExternal} from "./component/ExternalLink.jsx";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import ShoppingPage from './component/Page/ShoppingPage.jsx';
import HalloweenGuide from './component/Page/HalloweenGuide.jsx';
import ElliesGuide from './component/Page/ElliesGuide.jsx';
import BootGuide from './component/Page/BootGuide.jsx';
import LinksPage from './component/Page/LinksPage.jsx';
import { Feedback } from './component/Feedback.jsx';

const darkTheme = createTheme({
    palette: {
        mode: 'dark',
    },
});

ReactGA.initialize('G-P7FJTJXR7Z');
if (window.location.hostname === "localhost" || window.location.hostname.indexOf("dev") === 0) {
    window['ga-disable-G-P7FJTJXR7Z'] = true;
}


const LoginCorner = () => {
    const { user, token, currentUserProfile, setShowLoginDialog } = useAuth();

    if (user && token) {
        return currentUserProfile?.pic?.formats?.thumbnail ?
            <Avatar src={currentUserProfile.pic.formats.thumbnail.url} sx={{width: '30px', height: '30px'}} /> :
            <Avatar sx={{width: '30px', height: '30px' }} >{user.email.substring(0,2)}</Avatar>

    } else {
        return (
            <IconButton
                size={"small"}
                style={{color: "white"}}
                onClick={() => setShowLoginDialog(true)}
            >
                Login <LoginIcon />
            </IconButton>
    );
    }
};

export const App = () => {

    var dimensions = {};
    if (window.innerWidth < 600) {
        dimensions = {
            headerHeight: "135px",
            banner: "url(/logo-mobile.png)",
            width: "100%",
            stickyAt: "-70px"
        }
    } else {
        dimensions = {
            headerHeight: "305px",
            banner: "url(/logo-full.png)",
            width: "min(1080px,99vw)",
            stickyAt: "-170px"
        }
    }

    return (
        <Router>
        <ThemeProvider theme={darkTheme}>
            <CssBaseline enableColorScheme/>
                <AuthProvider>
                    <Feedback />
                    <RSVPProvider>
                    <Container style={{backgroundColor: "#393536", padding: 0, width: dimensions.width}}>
                        <div style={{position: "sticky", top: dimensions.stickyAt, backgroundColor: "#393536", zIndex: 100}}>
                            <div style={{position: "sticky", top: "0px",backgroundColor: "#393536", zIndex: "101"}}>
                                <Box flex={true} display="flex" justifyContent="space-between" alignItems="center" padding="5px 10px">
                                    <Box>
                                        <SiteMenu />
                                    </Box>
                                    <Box>
                                        <Button target="_blank" onClick={() => LogExternal("https://www.instagram.com/austin2step")} startIcon={<InstagramIcon size={"small"}/>} href="https://www.instagram.com/austin2step"/>
                                        <Button target="_blank" onClick={() => LogExternal("https://www.facebook.com/austin2step")} startIcon={<FacebookIcon size={"small"}/>} href="https://www.facebook.com/austin2step"/>
                                    </Box>
                                    <Box>
                                        <LoginCorner  />
                                    </Box>
                                </Box>
                            </div>
                            <div style={{
                                width: "100%",
                                height: dimensions.headerHeight,
                                overflow: "hidden",
                                backgroundImage: dimensions.banner,
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "top center"
                            }}>
                            </div>
                        </div>
                                <div style={{padding: '0px 10px 20px 10px', top: "-20px"}}>
                                        <DanceEventProvider >
                                            
                        <Switch>
                            
                            <Route path="/community/playlists/mine" component={AccountPlaylistPage}/>
                            <Route path="/community/instagram-posts/mine" component={AccountInstagramPage}/>
                            <Route path="/community/playlists" component={CommunityPlaylistPage}/>
                            <Route path="/community/instagram-posts" component={CommunityInstagramPostPage}/>
                            <Route path="/community/artists" component={ArtistListPage}/>
                            <Route path="/community/profiles" component={UserProfileListPage}/>
                            <Route path="/community/profile/:documentId" component={UserProfilePage}/>
                            <Route path="/halloween-guide" component={HalloweenGuide}/>
                            <Route path="/ellies-guide" component={ElliesGuide}/>
                            <Route path="/boot-guide" component={BootGuide}/>
                            <Route path="/links" component={LinksPage}/>
                            <Route path="/admin" component={AdminPage}/>
                            <Route path="/contact" component={Contact}/>
                            <Route path="/about" component={AboutPage}/>
                            <Route path="/auth" component={AuthPage}/>
                            <Route path="/announcements" component={AnnouncementList}/>
                            {/*<Route path="/dancecard" component={DanceCardPage}/>*/}
                            <Route path="/account/events" component={AccountEventsPage}/>
                            <Route path="/account/user" component={UserAccountPage}/>
                            <Route path="/account/" component={AccountPage}/>
                            <Route path="/community/user/:id" component={UserProfilePage}/>
                            <Route path="/community/" component={CommunityPage}/>
                            <Route path="/calendar-integration" component={CalendarIntegrationPage}/>
                            <Route path="/twostep-lessons" component={TwoStepLessons}/>
                            <Route path="/calendar/:date" component={DailyCalendarPage}/>
                            <Route path={DailyCalendarURI} component={DailyCalendarPage}/>
                            <Route path="/artist/:bandKey" component={ArtistPage}/>
                            <Route path="/event/edit/:id" component={EventEditPage}/>
                            <Route path="/event/create" component={EventEditPage}/>
                            <Route path="/event/:venueKey/:date" component={EventPage}/>
                            {/*<Route path="/fieldtrip" component={FieldTrip}/>*/}
                            <Route path="/date/:date" component={DailyCalendarPage}/>
                            <Route path="/quick-start-austin-2-step-guide" component={TwoStepGuide}/>
                            <Route path="/curator" component={CuratorPage}/>
                            <Route path="/contact" component={Contact}/>
                            <Route path="/privacy" component={PrivacyPage}/>
                            <Route path="/shopping" component={ShoppingPage}/>
                            <Route path="/venue/edit/:documentId" component={EditVenuePage}/>
                            <Route path={OutOfTownURI} component={VenueOutOfTownPage}/>
                            <Route path={InTownURI} component={VenueInTownPage}/>
                            <Route path="/content/:slug" component={ContentPage}/>
                            <Route path="/venue/:venueKey" component={VenuePage}/>
                            <Route path={OriginalCalendarURI} component={OriginalCalendarPage} />
                            <Route path="/where-to-dance" component={WhereToDancePage} />

                            <Route path="/">
                              <TodayPage />
                            </Route>
                        </Switch>
                      
                    </DanceEventProvider>
                    <SiteMap />
                </div>
              </Container>
              </RSVPProvider>

            </AuthProvider>
        </ThemeProvider>
        </Router>
    );

}

export default App;
